<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3">
            <Title :title="title">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-form ref="form">
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.name" 
                                    clearable 
                                    label="項目名" 
                                    outlined 
                                    type="text" 
                                    counter="20"
                                    :rules="[validatorRequire, validatorNameLength]" />
                            </v-col>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.unit" 
                                    clearable 
                                    label="単位"
                                    outlined 
                                    type="text" 
                                    counter="2"
                                    :rules="[validatorUnitLength]" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-select v-model="editItems.target" label="対象" outlined :items="targetList" item-text="text" item-value="value" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-switch v-if="editItems.isRequired" v-model="editItems.isRequired" label="この項目は観察時に必須入力とする" outlined />
                                <v-switch v-if="!editItems.isRequired" v-model="editItems.isRequired" label="この項目は観察時に任意入力とする" outlined />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        props: {
            observateItems: Array
        },
        components: {
            Title,
            TitleButton,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                target: null,        // 1:苗, 2:収穫物, 0:全て
                targetList: [
                    {value:1, text:"苗"},
                    {value:2, text:"収穫物"},
                    {value:0, text:"全て"},
                ],
                editItems: {
                    name: "",
                    unit: "",
                    target: null,
                    isRequired: true
                },
                targetItem: null,
                validatorRequire: value => !!value || '必須入力です。',
                validatorNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
                validatorUnitLength: value => value.length <= 2 || '2文字以内で入力して下さい。',
            }
        },
        computed: {
            title: function () {
                switch (this.target) {
                    case 1: return "苗の観察項目の編集"
                    case 2: return "収穫物の観察項目の編集"
                }
            }
        },
        methods: {
            onClickSave: function () {
                console.log("onClickSave")
                if (!this.$refs.form.validate()) {
                    console.log("input error!!")
                    return
                }
                
                const self = this
                const userUID = this.$store.getters["userUID"]

                this.$refs.confirm.show({
                    title: "観察項目の登録",
                    message: "観察項目を登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {

                        var observateItem = self.targetItem

                        if (observateItem == null) {
                            var id = 1
                            if (self.observateItems.length >= 1) {
                                id = Math.max(...self.observateItems.map(m => m.id)) + 1
                            }
                            var order = 1
                            if (self.observateItems.length >= 1) {
                                order = Math.max(...self.observateItems.map(m => m.order)) + 1
                            }
                            observateItem = {
                                version: "1.0.0",
                                id: id,
                                name: "",
                                order: order,
                                data: null,
                                unit: "",
                                target: null,
                                isRequired: null,
                                isSystemTemplate: false,
                                register: {
                                    userUID: userUID,
                                    dateTime: self.df_currentDateTime()
                                },
                                updater: {
                                    userUID: "",
                                    dateTime: ""
                                },
                            }
                        } else {
                            observateItem.updater.userUID = userUID,
                            observateItem.updater.dateTime = self.df_currentDateTime()
                        }

                        observateItem.name = self.editItems.name
                        observateItem.unit = self.editItems.unit
                        observateItem.target = self.editItems.target
                        observateItem.isRequired = self.editItems.isRequired

                        console.log("update item", observateItem)
                        db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").doc(""+observateItem.id).set(observateItem).then(function() {
                            self.$store.commit("notification", {message:"観察項目を登録しました。", isError:false})
                            if (self.targetItem == null) {
                                self.observateItems.push(place)
                            }
                            self.$emit("onUpdatedObservateItem", observateItem)
                            self.isView = false
                        }).catch (function (error) {
                            self.$store.commit("notification", {message:"観察項目の登録に失敗しました。", isError:true})
                        })
                        return true
                    },
                })
            },
            getTarget: function () {
                return this.target
            },
            show: function (targetItem) {
                // console.log("show", this.target)
                if (targetItem != null) {
                    this.targetItem = targetItem
                    this.editItems.name = targetItem.name
                    this.editItems.unit = targetItem.unit
                    this.editItems.target = targetItem.target
                    if (targetItem.isRequired == null || targetItem.isRequired == undefined) {
                        this.editItems.isRequired = true
                    } else {
                        this.editItems.isRequired = targetItem.isRequired
                    }
                } else {
                    this.targetItem = null
                    this.editItems.name = ""
                    this.editItems.unit = ""
                    this.editItems.target = this.target
                    this.editItems.isRequired = true
                }
                this.isView = true
            }
        }
    }
</script>
